import getBuildSlug from './build-slug';
import getDesignAutomation from './design-automation';
import getEmptyPageIgnoredBlocks from './empty-page-ignored-blocks';
import getMetaTranslations from './meta-translations';
import getPageContainerSelector from './page-container-selector';
import getPageTemplate from './page-template';
import getPageTemplates from './page-templates';
import getSocialIcons from './social-icons';
import getVariableValueByPath from './variable-value-by-path';
import getVariables from './variables';

export default {
  getBuildSlug,
  getDesignAutomation,
  getEmptyPageIgnoredBlocks,
  getMetaTranslations,
  getPageContainerSelector,
  getPageTemplate,
  getPageTemplates,
  getSocialIcons,
  getVariableValueByPath,
  getVariables,
};
